
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(1541|1779|5034)|11065|33446|43922|55827|66303|76779|78208|88684)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
